import { action, observable, makeObservable } from 'mobx';
import {contentLoaders, SuccessResponse, X1LanguageUpdateModel} from '../../../../domain';
import {HttpPromiseState, SaveStateHolder, StringControl, validators} from '../../../../lib/helpers';

export class AddLanguageStore implements SaveStateHolder {
  name: StringControl;

  @observable.ref
  save: HttpPromiseState<SuccessResponse> | null;

  constructor() {
    makeObservable(this);
    this.name = new StringControl('name', '', validators.required);
    this.save = null;
  }

  @action
  complete = () => {
    if (this.save?.isPending === true)
      return;
    this.name.markTouched();
    if (this.name.invalid)
      return;
    const model: X1LanguageUpdateModel = {
      Name: this.name.value
    };
    this.save = contentLoaders.x1language.insert(model);
  };
}
